import Text from '@ui/text/text/text';
import Checkbox from '@/general-ui/checkbox/checkbox';
import Button from '@ui/buttons/button/button';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';

interface CampaignsTableHeaderProps {
  allSelected: boolean;
  partialSelected: boolean;
  onSelectAll: () => void;
  selectedCount: number;
  onClearSelection: () => void;
  deleteSelected: () => void;
}

const CampaignsTableHeader = ({
  allSelected,
  partialSelected,
  onSelectAll,
  selectedCount,
  onClearSelection,
  deleteSelected,
}: CampaignsTableHeaderProps) => {
  if (selectedCount > 0) {
    return (
      <>
        <th
          style={{
            width: '40px',
            backgroundColor: 'var(--global-cont-1)',
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px',
          }}
          className="padding-8"
        >
          <Checkbox
            checked={allSelected}
            partial={partialSelected}
            onChange={onSelectAll}
            value="select-all"
            size={16}
          />
        </th>
        <th
          colSpan={6}
          style={{
            backgroundColor: 'var(--global-cont-1)',
            borderTopRightRadius: '8px',
            borderBottomRightRadius: '8px',
          }}
          className="padding-8"
        >
          <div className="flex ai-center gap-16">
            <Text className="P2" style={{ fontWeight: 600 }} color="var(--global-ico-text-1)">
              {selectedCount} Email campaign{selectedCount !== 1 ? 's' : ''} selected
            </Text>
            <div className="flex ai-center gap-8 margin-l-auto">
              <Button className="flex ai-center gap-4" onClick={deleteSelected} design="LocalBttnCritical">
                <Icon name={ICONS.TRASH} size={10} />
                <Text className="L2" design="LocalBttnCritical">
                  Delete Campaigns
                </Text>
              </Button>
              <Button clear onClick={onClearSelection} className="padding-0 flex ai-center gap-8">
                <Icon name={ICONS.CLOSE} size={12} color="var(--global-ico-text-1)" />
                <Text className="P2" style={{ fontWeight: 600 }} color="var(--blue-500)">
                  Clear selection
                </Text>
              </Button>
            </div>
          </div>
        </th>
      </>
    );
  }

  return (
    <>
      <th style={{ width: '40px' }} className="padding-8">
        <Checkbox checked={allSelected} onChange={onSelectAll} value="select-all" size={16} />
      </th>
      <th>
        <Text fontSize="12px" style={{ fontWeight: 600 }} color="var(--global-ico-text-3)">
          NAME
        </Text>
      </th>
      <th>
        <Text fontSize="12px" style={{ fontWeight: 600 }} color="var(--global-ico-text-3)">
          TYPE
        </Text>
      </th>
      <th>
        <Text fontSize="12px" style={{ fontWeight: 600 }} color="var(--global-ico-text-3)">
          DATE SCHEDULED
        </Text>
      </th>
      <th>
        <Text fontSize="12px" style={{ fontWeight: 600 }} color="var(--global-ico-text-3)">
          AUDIENCES
        </Text>
      </th>
      {/* <th>
        <Text fontSize="12px" style={{ fontWeight: 600 }} color="var(--global-ico-text-3)">
          SENT
        </Text>
      </th>
      <th>
        <Text fontSize="12px" style={{ fontWeight: 600 }} color="var(--global-ico-text-3)">
          CLICK RATE
        </Text>
      </th> */}
      <th>
        <Text fontSize="12px" style={{ fontWeight: 600 }} color="var(--global-ico-text-3)">
          STATUS
        </Text>
      </th>
    </>
  );
};

export default CampaignsTableHeader;
